// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (-ms-high-contrast:active),(-ms-high-contrast:none){.ie-srf[data-v-714d38c7]{height:30px}}ul li[data-v-714d38c7]:before{content:\" \"}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
